// native
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// service
import { ApiService } from './api.service';
import { GlobalsService } from './globals.service';

// model
import { ISmartList, ISmartlistDataResponse } from '../../models';

export interface IDataSmartListQueryParams {
  collection_id: string;
}

@Injectable({
  providedIn: 'root'
})
export class SmartlistService {
  constructor(
    private apiService: ApiService,
    private globalsService: GlobalsService
  ) {
  }


  getSmartlists(params?: IDataSmartListQueryParams): Observable<ISmartList[]> {
    const endpointUrl = `${this.globalsService.appConfig.environment.baseUrls.sync}/collections/${params.collection_id}/smartlists`;
    return this.apiService.get(endpointUrl).pipe(
      map((body: ISmartlistDataResponse) => this.mapSmartListData(body.smartlists || [])),
      map((smartlists: ISmartList[]) => smartlists.filter(l => l.collection_id === params.collection_id))
    );
  }

  private mapSmartListData(smartlists: any): ISmartList[] {

    return smartlists.map((smartlist: ISmartList) => {
      return {
        id: smartlist.id,
        collection_id: smartlist.collection_id,
        name: smartlist.name || '',
        deleted: smartlist.deleted || false,
        query: smartlist.query || '',
        created: smartlist.created || null,
        modified: smartlist.modified || null,
        incomplete: smartlist.incomplete || false
      };
    });
  }
}